import { render, staticRenderFns } from "./TableOKRs.vue?vue&type=template&id=63e8c2d0"
import script from "./TableOKRs.vue?vue&type=script&lang=js"
export * from "./TableOKRs.vue?vue&type=script&lang=js"
import style0 from "./TableOKRs.vue?vue&type=style&index=0&id=63e8c2d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports